import { TRESPONSE_MASTER_DATA } from '@monorepo/types';
import { MasterDataActionTypes, TMasterDataActions } from './master-data-db.actions';

export enum MasterDataDBTypes {
  BUNDLES = 'BUNDLES',
}

export type TMasterDataDatabases = {
  entities: {
    [MasterDataDBTypes.BUNDLES]: {
      [bundleId: string]: {
        req_id: string;
        data: TRESPONSE_MASTER_DATA['response'][number]['data'];
      };
    };
  };
  result: string[];
};
const initialState: TMasterDataDatabases = {
  entities: {
    BUNDLES: {},
  },
  result: [],
};

export function masterDataReducer(state = initialState, action: TMasterDataActions): TMasterDataDatabases {
  switch (action.type) {
    case MasterDataActionTypes.MasterDataLoaded:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
}
export const MASTER_DATA_DB = 'masterDataDB';
